<template>
  <v-container fill-height fluid pl-0 pr-0 align-start>
    <v-layout column>

      <v-container class="l-container">
        <ul class="table-of-content">
          <li v-for="item in tableOfContent" :key="item.id">
            <a :href="'#' + item.id" @click.prevent="$router.push({hash: item.id})">
              <v-icon>arrow_right</v-icon> {{ item.text }}
            </a>
          </li>
        </ul>
      </v-container>

      <v-container class="l-container" ref="cardList">
        <div class="l-row">
          <v-card id="cardFAQ" class="bold-orange">
            <v-card-title class="headline">
              <span class="primary--text" v-html="$t('TXT.ABOUT_US_PAGE_FAQ_CARD_TITLE')"></span>
            </v-card-title>
            <v-card-text v-html="$t('TXT.ABOUT_US_PAGE_FAQ_CARD_TEXT_HTML')" @click="onClickCardContent"></v-card-text>
          </v-card>
        </div>

        <div class="l-row">
          <v-card id="cardWorldClass" class="bold-orange">
            <v-card-title class="headline">
              <span class="primary--text" v-html="$t('TXT.ABOUT_US_PAGE_WORLDCLASS_CARD_TITLE')"></span>
            </v-card-title>
            <v-card-text v-html="$t('TXT.ABOUT_US_PAGE_WORLDCLASS_CARD_TEXT_HTML')" @click="onClickCardContent"></v-card-text>
          </v-card>
        </div>

        <div class="l-row">
          <v-card id="cardAssAns" class="bold-orange">
            <v-card-title class="headline">
              <span class="primary--text" v-html="$t('TXT.ABOUT_US_PAGE_ASSANS_CARD_TITLE')"></span>
            </v-card-title>
            <v-card-text v-html="$t('TXT.ABOUT_US_PAGE_ASSANS_CARD_TEXT_HTML', ['<i class=\'material-icons\'>panorama_fish_eye</i>'])" @click="onClickCardContent"></v-card-text>
          </v-card>
        </div>

        <div class="l-row">
          <v-card id="cardLikelihood" class="bold-orange">
            <v-card-title class="headline">
              <span class="primary--text" v-html="$t('TXT.ABOUT_US_PAGE_LIKELIHOOD_CARD_TITLE')"></span>
            </v-card-title>
            <v-card-text v-html="$t('TXT.ABOUT_US_PAGE_LIKELIHOOD_CARD_TEXT_HTML')" @click="onClickCardContent"></v-card-text>
          </v-card>
        </div>

        <div class="l-row">
          <v-card id="cardOTARC">
            <v-card-title class="headline">
              <span class="primary--text" v-html="$t('TXT.ABOUT_US_PAGE_OTARC_CARD_TITLE')" @click="onClickCardContent"></span>
            </v-card-title>
            <v-card-text v-html="$t('TXT.ABOUT_US_PAGE_OTARC_CARD_TEXT_HTML')"></v-card-text>
          </v-card>
        </div>

        <div class="l-row">
          <v-card id="cardPeople">
            <v-card-title class="headline">
              <span class="primary--text" v-html="$t('TXT.ABOUT_US_PAGE_PEOPLE_CARD_TITLE')"></span>
            </v-card-title>
            <v-card-text>
              <v-layout column
                v-for="person in people" :key="person.name">
                <v-layout v-if="person.isOrg">
                  <v-flex>
                    <img class="responsive-img" :src="person.profilePic" v-if="person.profilePic">
                  </v-flex>
                </v-layout>
                <v-layout row align-center>
                  <v-flex xs2 pl-2 pr-2>
                    <img class="responsive-img" :src="person.profilePic" v-if="person.profilePic && !person.isOrg">
                  </v-flex>
                  <v-flex xs10 pl-2 pr-2>
                    <div class="black--text"><strong>{{ person.name }}</strong></div>
                    <div v-for="title in person.titles" :key="title">{{ title }}</div>
                    <p class="grey--text mb-0" v-html="person.description" v-if="person.description"></p>
                  </v-flex>
                </v-layout>
              </v-layout>

              <div class="l-row pa-4">
                <strong>{{ $t('TXT.ABOUT_US_PAGE_PEOPLE_CARD_WITH_THANKS_TO')}}</strong>
                <div v-for="person in otherPeople" :key="person">
                  {{ person }}
                </div>
              </div>
            </v-card-text>
          </v-card>
        </div>

      </v-container>
    </v-layout>

    <bottom-toolbar v-if="!userObject"></bottom-toolbar>
  </v-container>
</template>

<script>
import BottomToolbar from '@/components/elements/BottomToolbar'
import { mapState } from 'vuex'

export default {
  name: 'AboutUsPage',
  components: {
    'bottom-toolbar': BottomToolbar
  },
  computed: {
    ...mapState([
      'userObject'
    ])
  },
  created () {
    this.$store.commit('UPDATE_APP_STEP', 3)
  },
  data () {
    const people = [
      {
        name: this.$i18n.t('TXT.ABOUT_US_PAGE_PEOPLE_CARD_PER1_NAME'),
        profilePic: require('../../assets/images/avatar-josie.png'),
        titles: this.$i18n.t('TXT.ABOUT_US_PAGE_PEOPLE_CARD_PER1_TITLES').split(';'),
        description: this.$i18n.t('TXT.ABOUT_US_PAGE_PEOPLE_CARD_PER1_DESC_HTML')
      },
      {
        name: this.$i18n.t('TXT.ABOUT_US_PAGE_PEOPLE_CARD_PER2_NAME'),
        profilePic: require('../../assets/images/avatar-cheryl.png'),
        titles: this.$i18n.t('TXT.ABOUT_US_PAGE_PEOPLE_CARD_PER2_TITLES').split(';'),
        description: this.$i18n.t('TXT.ABOUT_US_PAGE_PEOPLE_CARD_PER2_DESC_HTML')
      },
      {
        name: this.$i18n.t('TXT.ABOUT_US_PAGE_PEOPLE_CARD_PER3_NAME'),
        profilePic: require('../../assets/images/avatar-nancy.png'),
        titles: this.$i18n.t('TXT.ABOUT_US_PAGE_PEOPLE_CARD_PER3_TITLES').split(';'),
        description: this.$i18n.t('TXT.ABOUT_US_PAGE_PEOPLE_CARD_PER3_DESC_HTML')
      },
      {
        name: this.$i18n.t('TXT.ABOUT_US_PAGE_PEOPLE_CARD_PER4_NAME'),
        profilePic: require('../../assets/images/avatar-wojciech.png'),
        titles: this.$i18n.t('TXT.ABOUT_US_PAGE_PEOPLE_CARD_PER4_TITLES').split(';'),
        description: this.$i18n.t('TXT.ABOUT_US_PAGE_PEOPLE_CARD_PER4_DESC_HTML')
      },
      {
        name: this.$i18n.t('TXT.ABOUT_US_PAGE_PEOPLE_CARD_PER5_NAME'),
        profilePic: require('../../assets/images/avatar-lael.png'),
        titles: this.$i18n.t('TXT.ABOUT_US_PAGE_PEOPLE_CARD_PER5_TITLES').split(';'),
        description: this.$i18n.t('TXT.ABOUT_US_PAGE_PEOPLE_CARD_PER5_DESC_HTML')
      },
      {
        name: this.$i18n.t('TXT.ABOUT_US_PAGE_PEOPLE_CARD_PER6_NAME'),
        profilePic: require('../../assets/images/avatar-olga-tennison.png'),
        titles: this.$i18n.t('TXT.ABOUT_US_PAGE_PEOPLE_CARD_PER6_TITLES').split(';'),
        description: this.$i18n.t('TXT.ABOUT_US_PAGE_PEOPLE_CARD_PER6_DESC_HTML')
      },
      {
        name: this.$i18n.t('TXT.ABOUT_US_PAGE_PEOPLE_CARD_PER7_NAME'),
        profilePic: require('../../assets/images/logo-ltu.png'),
        titles: this.$i18n.t('TXT.ABOUT_US_PAGE_PEOPLE_CARD_PER7_TITLES').split(';'),
        description: this.$i18n.t('TXT.ABOUT_US_PAGE_PEOPLE_CARD_PER7_DESC_HTML')
      },
      {
        name: this.$i18n.t('TXT.ABOUT_US_PAGE_PEOPLE_CARD_PER8_NAME'),
        profilePic: require('../../assets/images/logo-salesforce-small.png'),
        titles: this.$i18n.t('TXT.ABOUT_US_PAGE_PEOPLE_CARD_PER8_TITLES').split(';'),
        description: this.$i18n.t('TXT.ABOUT_US_PAGE_PEOPLE_CARD_PER8_DESC_HTML')
      }
    ]

    people.forEach(person => {
      person.isOrg = !!person.name.match(/(la ?trobe|salesforce)/i)
    })

    return {
      people: people,
      otherPeople: this.$i18n.t('TXT.ABOUT_US_PAGE_PEOPLE_CARD_WITH_THANKS_TO_OTHERS').split(';'),
      tableOfContent: [
        {
          id: 'cardFAQ',
          text: this.$i18n.t('TXT.ABOUT_US_PAGE_FAQ_CARD_TITLE')
        },
        {
          id: 'cardWorldClass',
          text: this.$i18n.t('TXT.ABOUT_US_PAGE_WORLDCLASS_CARD_TITLE')
        },
        {
          id: 'cardAssAns',
          text: this.$i18n.t('TXT.ABOUT_US_PAGE_ASSANS_CARD_TITLE')
        },
        {
          id: 'cardLikelihood',
          text: this.$i18n.t('TXT.ABOUT_US_PAGE_LIKELIHOOD_CARD_TITLE')
        },
        {
          id: 'cardOTARC',
          text: this.$i18n.t('TXT.ABOUT_US_PAGE_OTARC_CARD_TITLE')
        },
        {
          id: 'cardPeople',
          text: this.$i18n.t('TXT.ABOUT_US_PAGE_PEOPLE_CARD_TITLE')
        }
      ]
    }
  },
  methods: {
    onClickCardContent (e) {
      if (e.target.nodeName === 'A') {
        const href = e.target.getAttribute('href')
        if (href[0] === '#') {
          e.preventDefault()
          this.$router.push({hash: e.target.getAttribute('href')})
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/styles/_colors';

.table-of-content {
  padding-left: 1.5em;
  margin-bottom: 1em;

  li {
    list-style: none;
    line-height: 30px;

    a {
      text-decoration: none;
      display: inline-block;
    }

    a, i.material-icons {
      color: $blue-darken1;
    }
  }
}

.card__title {
  text-transform: uppercase;
  color: $amber-darken4;

  .lang-zh & {
    color: $blue-darken2;
  }
}

.card__text {
  .row {
    padding-bottom: 20px;
    margin-bottom: 10px;
    border-bottom: 1px solid #999999;
  }

  & /deep/ ol {
    padding-left: 2.5em;
    margin-bottom: 0.5em;
    line-height: 1.5;
  }
}

.bold-orange {
  .card__text {
    & /deep/ strong {
      color: $amber-darken4;

      .lang-zh & {
        color: $blue-darken2;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/AboutUsPage.vue